module.exports = __webpack_public_path__ + "static/media/closeLightBtn.1b421629.svg";